<template>
    <!-- :class="img" -->
    <div class="base_header_img" :class="img">
        <img
            v-if="img === 'Page02_02'"
            class="base_header_img_bg"
            src="../../../assets/Page02_02.jpeg"
        />
        <img
            v-if="img === 'page_02'"
            class="base_header_img_bg"
            src="../../../assets/page_02.jpeg"
        />
        <img
            v-if="img === 'page_03'"
            class="base_header_img_bg"
            src="../../../assets/page_03.jpeg"
        />
        <img
            v-if="img === 'page_04'"
            class="base_header_img_bg"
            src="../../../assets/page_04.jpeg"
        />
        <img
            v-if="img === 'page_05'"
            class="base_header_img_bg"
            src="../../../assets/page_05.jpeg"
        />

        <div class="base_header_content">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'BaseHeaderImg',
    props: {
        img: {
            type: String,
            default: ''
        }
    }
}
</script>
<style>
.base_header_img {
    height: 700px;
    position: relative;
    background-size: 100% auto;
    background-position: center center;
    background-repeat: no-repeat;
}
.base_header_img .base_header_img_bg {
    height: 100%;
    width: 100%;
    object-fit: cover;
}
/* .Page02_02 {
    background-image: url("../../../assets/Page02_02.jpeg");
}
.page_02 {
    background-image: url("../../../assets/page_02.jpeg");
}
.page_03 {
    background-image: url("../../../assets/page_03.jpeg");
}
.page_04 {
    background-image: url("../../../assets/page_04.jpeg");
} */
.page_05 {
    height: 400px;
}
.page_05 .base_header_content {
    bottom: 200px;
}

.base_header_content {
    font-size: 64px;
    color: #ffffff;
    position: absolute;
    bottom: 300px;
    text-shadow: 0px 0px 14px rgba(16, 14, 150, 0.53);
    text-align: center;
    width: 100%;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/base/base-header-img.vue